<template>
  <div class="grid grid-cols-6 gap-6">
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="codigo" class="block text-sm font-medium text-gray-700">Código</label>
      <input type="number" id="codigo" :value="loadData.codigo"
              @change="(codigoFuenteNew)=>$emit('updateValues', {'codigo': customUpdateValueData('codigo', codigoFuenteNew.target.value)})"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="nombre" class="block text-sm font-medium text-gray-700">Nombre</label>
      <input type="text" id="nombre" :value="loadData.nombre"
              @change="(nombreFuenteNew)=>$emit('updateValues', {'nombre': customUpdateValueData('nombre', nombreFuenteNew.target.value)})"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="id_fuente_macro" class="block text-sm font-medium text-gray-700">Fuente Macro</label>
        <select id="id_fuente_macro" :value="loadData.id_fuente_macro"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @change="(idFuenteMacroNew)=>$emit('updateValues', {'id_fuente_macro': customUpdateValueData('id_fuente_macro', idFuenteMacroNew.target.value)})">
          <option value="" selected>Seleccione una fuente macro ...</option>
          <option v-for="(fuenteMacro, index) of collectionFuenteMacro" :key="'B'+index" :value="fuenteMacro.id">{{
              fuenteMacro.nombre
            }}
          </option>
        </select>
      </div>
  </div>
</template>

<script>
export default {
  name: 'FuentesConcretasCrearActualizarComponent',
  props: ['loadData', 'collectionFuenteMacro', 'customUpdateValueData'],
  emits: ["updateValues"],
}
</script>